import ValueLabel from "./valueLabel";
class FormData {
    village_cities:ValueLabel[]=[]
    account_types: ValueLabel[] = [];
    billing_review_types: ValueLabel[] = [];
    cities: ValueLabel[] = [];
    construction_document_type: ValueLabel[] = [];
    legal_facilities_request_type: ValueLabel[] = [];
    units: ValueLabel[] = [
        new ValueLabel("1", "1"),
        new ValueLabel("2", "2"),
        new ValueLabel("3", "3"),
        new ValueLabel("4", "4"),
        new ValueLabel("5", "5"),
        new ValueLabel("6", "6"),
        new ValueLabel("7", "7"),
        new ValueLabel("8", "8"),
        new ValueLabel("9", "9"),
        new ValueLabel("10", "10"),
    ];
}

export default FormData;